import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { ZOOM_KB_ARTICLE_URL } from '../../../constants/KnowledgeBaseUrls';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { Box } from 'foundations-components/transitional/components/Box';
import { useTheme } from 'styled-components';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NoUserAssignedThirdPartyEmptyState = props => {
  const {
    callSource
  } = props;
  const attrs = callSource ? {
    options: {
      callSource
    }
  } : null;
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustration: "integrations",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.transcript.transcriptEmptyStates.noTranscriptAvailable"
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: callSource ? /*#__PURE__*/_jsx(FormattedMessage, Object.assign({
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.callSource.linkYourAccount"
      }, attrs)) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.transcript.transcriptEmptyStates.callSource.linkYourAccountGenericApp"
      })
    })
  });
};
export const NoUserAssignedZoomEmptyState = () => {
  const attrs = {
    elements: {
      KnowledgeBaseButton
    },
    options: {
      url: ZOOM_KB_ARTICLE_URL
    }
  };
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    paddingBlockStart: "1500",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(Box, {
        shrink: 0,
        basis: theme.space['800'],
        children: /*#__PURE__*/_jsx(SprocketIcon, {
          color: 'fill-brand-default',
          size: "800"
        })
      }), /*#__PURE__*/_jsx(Box, {
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(AddIcon, {
          size: "400"
        })
      }), /*#__PURE__*/_jsx(Box, {
        shrink: 0,
        basis: "50px",
        children: /*#__PURE__*/_jsx(Logo, {
          name: "zoom",
          width: "100%"
        })
      })]
    }), /*#__PURE__*/_jsxs(Text, {
      as: "div",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        paddingBlockStart: "500",
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "recordingReviewComponents.transcript.transcriptEmptyStates.noTranscriptAvailable"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
          message: "recordingReviewComponents.transcript.transcriptEmptyStates.callSource.linkYourAccountZoom_jsx"
        }, attrs))
      })]
    })]
  });
};